import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { FiScissors, FiLogOut, FiHome, FiCalendar, FiUsers, FiSettings } from 'react-icons/fi';
import Swal from 'sweetalert2';

const AdminNavbar = () => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will be logged out from the admin panel.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#7c3aed', // purple-600
      cancelButtonColor: '#6b7280', // gray-500
      confirmButtonText: 'Yes, logout!',
      cancelButtonText: 'Cancel',
      background: '#1f2937', // gray-800
      color: '#f3f4f6', // gray-100
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
      }
    });
  };

  return (
    <nav className="bg-gray-800 px-6 py-4 shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <Link to="/admin" className="flex items-center space-x-2">
          <FiScissors className="text-purple-500 text-2xl" />
          <span className="text-xl font-bold bg-gradient-to-r from-purple-500 to-pink-500 bg-clip-text text-transparent">
            Salon Admin
          </span>
        </Link>
        
        <div className="flex items-center space-x-6">
          <Link to="/admin" className="flex items-center text-gray-300 hover:text-purple-400 transition">
            <FiHome className="mr-1" /> Dashboard
          </Link>
          <Link to="/admin/appointments" className="flex items-center text-gray-300 hover:text-purple-400 transition">
            <FiCalendar className="mr-1" /> Appointments
          </Link>
          <Link to="/admin/staff" className="flex items-center text-gray-300 hover:text-purple-400 transition">
            <FiUsers className="mr-1" /> Staff
          </Link>
          <Link to="/admin/settings" className="flex items-center text-gray-300 hover:text-purple-400 transition">
            <FiSettings className="mr-1" /> Settings
          </Link>
          
          {user && (
            <button 
              onClick={handleLogout}
              className="flex items-center text-gray-300 hover:text-red-400 transition"
            >
              <FiLogOut className="mr-1" /> Logout
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;